
import * as React from 'react';
import { ActivityItem, IActivityItemProps, Icon, Link, PrimaryButton, Text, TextField } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/merge-styles';
import { toastRef } from '../../../../Layout/Layout';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import protocolsService from '../../../../../services/protocols.service';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { IAnnotazione, IProtocol } from '../../../../../shared/interfaces';
import Utilities from '../../../../../shared/Utilities/utilities';
import { RootState } from '../../../../../store';
import { useBoolean } from '@fluentui/react-hooks';

const classNames = mergeStyleSets({
    exampleRoot: {
        paddingTop: '25px'
    },
    nameText: {
        fontWeight: 'bold',
    },
});

export interface AnnotazioniProps {
    protocol: IProtocol
    forceAnnotazioneRefresh?: boolean,
    onAnnotazioneInputChangedHandler: (event, newValue) => void
    extraCssClass?: string
}

const Annotazioni: React.FunctionComponent<AnnotazioniProps> = (props) => {

    const [activityItems, setActivityItems] = useState<any[]>([])
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);
    let [textAreaValue, setTextAreaValue] = useState<string>('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentAoo && props.protocol) {
            getAnnotazioni();
            setTextAreaValue('');
        }
    }, [props.forceAnnotazioneRefresh]);

    const getAnnotazioni = () => {
        setLoading(true);
        protocolsService.getAnnotazioniProtocollo(currentAoo!.id, currentUor?.id!, props.protocol!.protocolId!)
            .then(response => {
                mapActivityItems(response);

                setLoading(false);
            })
            .catch(error => {
                console.error("Errore nel recupero delle annotazioni", error);
                setLoading(false);
            });

    }

    const mapActivityItems = (items: IAnnotazione[]) => {
        let activities: any[] = [];
        items.forEach(el => {
            let userName = el.utente?.split('<')[0];
            let item: IActivityItemProps = {
                activityDescription: [
                    <Link key={2} className={classNames.nameText}>{userName}</Link>,
                    <div key={1}>{el.testo}</div>,

                ],
                activityIcon: <Icon iconName={'Message'} />,
                timeStamp: getActivityTimeStamp(el.dataInserimento!),

            };
            activities.push({ key: el.id, ...item });
        });
        setActivityItems(activities);
    }

    const onInputChangeHandler = (event, newValue) => {
        setTextAreaValue(newValue);
        props.onAnnotazioneInputChangedHandler(event,newValue != undefined ? newValue : '');
    }

    //metodo per il render della data + ora
    const getActivityTimeStamp = (date: Date) => {
        return Utilities.FormatDate(date, false);
    };

    return (
        <div className={`storia flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={`position-relative my-scroll-div`}>
                <div className={`my-component-content`}>
                    {
                        
                        <TextField
                            multiline
                            maxLength={500}
                            autoAdjustHeight={true}
                            required={true}
                            value={textAreaValue}
                            onChange={onInputChangeHandler}
                        />
                    }
                    
                    {
                        activityItems.length > 0 && activityItems.map((item: { key: string | number }) => (
                        <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
                    ))
                    }
                    {
                        
                            activityItems.length === 0 &&

                        <Text block style={{ paddingTop: 10 }}>Nessuna annotazione presente.</Text>
                    
                    }
                    
                </div>

            </div>

        </ div>
    );
};


export default Annotazioni;





